/**
 * Enum representing the lifecycle status of door access codes in the system.
 * Used to track whether codes are currently valid, scheduled for removal, or already removed.
 */
export enum DoorCodeStatus {
  /**
   * The door code is currently active and can be used for access.
   */
  active = 'active',

  /**
   * The door code is scheduled for deletion but still temporarily valid.
   */
  pendingDelete = 'pendingDelete',

  /**
   * The door code has been deleted and is no longer valid for access.
   */
  deleted = 'deleted',
}
